const LANGUAGE = {
  COPY_BE_KIND: "दयालु हों",
  COPY_VERSION: "संस्करण",

  COPY_SETTINGS_PROFILE: "प्रोफ़ाइल",
  COPY_SETTINGS_FREQUENTLY_ASKED_QUESTIONS: "अक्सर पूछे जाने वाले प्रश्नों",
  COPY_SETTINGS_LANGUAGE: "भाषा",
  COPY_SETTINGS_PAYMENTS: "भुगतान",
  COPY_SETTINGS_CURRENCY: "मुद्रा",
  COPY_SETTINGS_TIMEZONE: "समय क्षेत्र",
  COPY_SETTINGS_COUNTRY: "देश",
  COPY_SETTINGS_CONTACT_US: "संपर्क करें",
  COPY_SETTINGS_PLAYGROUND: "विकास",

  COPY_SEARCH_ORDER_BY:
    "परिणाम लागत-प्रभावशीलता द्वारा निर्धारित किए जाते हैं खैर दो",
  COPY_SEARCH: "खोज",
  COPY_TAG_MEDICAL_RESEARCH: "कैंसर अनुसन्धान",
  COPY_TAG_ENVIRONMENT: "पर्यावरण",
  COPY_TAG_PEACE: "वैश्विक संघर्ष",
  COPY_TAG_CHILDREN: "बच्चे",
  COPY_TAG_MENTAL_HEALTH: "मानसिक स्वास्थ्य",
  COPY_TAG_WOMENS_RIGHTS: "घरेलू हिंसा",
  COPY_TAG_LGBTQ: "LGBTQA+",
  COPY_TAG_FOOD_AND_SHELTER: "बेघर",
};

export default LANGUAGE;
